import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";
import { Formik } from "formik";
import Common from "us.common";
import * as Actions from "us.collection.admin/actions";
import {
  $Collapse,
  $FormItem,
  $Tooltip,
  $Typography,
} from "us.common/components";
import { MinusOutlined, PlusOutlined } from "us.icons";
import { ContactPersonsInfoTable } from "./Components";
import { RootState } from "us.helper/types";
const { $Button, $Input, $Form, $Row, $Col } = Common.Components;
const { Paragraph } = $Typography;
/**
 * @description - Add New Creditor Approval drawer component to give Approval
 */
export type NewCreditorApprovalProps = {
  onClose(): void;
  drawerData: any;
  isLoading: boolean;
};

const NewCreditorApproval: React.FC<PropsFromRedux & NewCreditorApprovalProps> =
  memo((props) => {
    const { t } = useTranslation([
      "US.COLLECTION.ADMIN",
      "US.COLLECTION.COMMON",
    ]);
    const { addNewCreditorApproval, drawerData, onClose } = props;

    const submitFormData = (values: any, isApproval: boolean) => {
      addNewCreditorApproval &&
        addNewCreditorApproval({
          data: { RequestId: values?.requestId, IsApproved: isApproval },
        });
      onClose();
    };

    return (
      <Formik
        initialValues={drawerData?.record}
        onSubmit={(values: any, actions: any) => {
          actions.setSubmitting(true);
        }}
      >
        {({ values }) => {
          return (
            <div>
              <$Form className="add-new-creditor-approval-form">
                <$Row gutter={16} className="mb-2">
                  <$Col span={8}>
                    <$FormItem
                      label={t("US.COLLECTION.COMMON:COMMON.CREDITOR_GROUP")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="creditorGroupNo"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.CREDITOR:SELECTEDCREDITOR.CREDITOR_NUMBER"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="creditorNumber"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.CREDITOR:CREDITOR_INFO.CREDITOR_NAME"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="name"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                </$Row>
                <$Row gutter={16} className="mb-2">
                  <$Col span={8}>
                    <$FormItem
                      label={t("US.COLLECTION.CREDITOR:CREDITOR_INFO.NIN")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="orgNumber"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.CREDITOR:CREDITOR_INFO.BELONGS_TO"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="masterCreditorNo"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                </$Row>
                <$Row gutter={16} className="mb-2">
                  <$Col span={8}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.ADMIN:CREDITOR_APPROVAL.BANK_ACCOUNT_NUMBER"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="bankAccountNumber"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.CREDITOR:CREDITOR_INFO.REMIT_ACCOUNT_NO"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="remitAccountNumber"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.ADMIN:CREDITOR_APPROVAL.OTHER_KID_BANK_ACCOUNT"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="otherKIDBankAccount"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                </$Row>
                <$Row gutter={16} className="mb-2">
                  <$Col span={4}>
                    <$FormItem
                      label={t("US.COLLECTION.CREDITOR:BASICINFO.COUNTRY")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="country"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={4}>
                    <$FormItem
                      label={t("US.COMMON:COMMON.POSTAL_CODE")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="postalCode"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t("US.COLLECTION.DEBTOR:ADDRESSHISTORY.ADDRESS1")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="address1"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t("US.COLLECTION.DEBTOR:ADDRESSHISTORY.ADDRESS2")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="address2"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                </$Row>
                <$Row gutter={16} className="mb-2">
                  <$Col span={4}>
                    <$FormItem
                      label={t("US.COLLECTION.CREDITOR:INFO.MOBILE")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="telMobile"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={4}>
                    <$FormItem
                      label={t("US.COLLECTION.CASE:NOTESANDMESSAGES.SMS")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="smsNumber"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={4}>
                    <$FormItem
                      label={t("US.COLLECTION.CREDITOR:INFO.HOME")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="telHome"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={4}>
                    <$FormItem
                      label={t("US.COLLECTION.CREDITOR:INFO.WORK")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="telWork"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t("US.COLLECTION.COMMON:COMMON.EMAIL")}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="email"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                </$Row>
                <$Row gutter={16} className="mb-2">
                  <$Col span={4}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.ADMIN:CREDITOR_APPROVAL.VAT_STATUS"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="vatStatus"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={4}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.ADMIN:CREDITOR_APPROVAL.DEDUCT_VAT_FROM_CREDITOR"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="deductVATFromCreditor"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={t(
                        "US.COLLECTION.ADMIN:CREDITOR_APPROVAL.KID_REMIT"
                      )}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Input
                        name="kidRemit"
                        size="small"
                        disabled={true}
                        className="form-control"
                        label={undefined}
                      />
                    </$FormItem>
                  </$Col>
                  <$Col span={8}>
                    <$FormItem
                      label={
                        <div className="d-flex align-items-center">
                          <span className="me-2">
                            {t(
                              "US.COLLECTION.ADMIN:CREDITOR_APPROVAL.EHF_FREE_TEXT"
                            )}
                          </span>
                          <Paragraph
                            className="mb-0"
                            copyable={{
                              text: values?.ehF_FreeText,
                              tooltips: [
                                t(
                                  "US.COLLECTION.COMMON:COMMON.COPY_TO_CLIPBOARD"
                                ),
                                t("US.COLLECTION.COMMON:COMMON.COPIED"),
                              ],
                            }}
                          />
                        </div>
                      }
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                    >
                      <$Tooltip placement="top" title={values?.ehF_FreeText}>
                        <span>
                          <$Input
                            name="ehF_FreeText"
                            size="small"
                            disabled
                            className="text-truncate"
                            value={values?.ehF_FreeText}
                            label={undefined}
                          />
                        </span>
                      </$Tooltip>
                    </$FormItem>
                  </$Col>
                </$Row>

                {values.contactPersons && values.contactPersons.length > 0 && (
                  <div
                    className="editcreditor-info"
                    style={{ marginLeft: 0, paddingLeft: 0 }}
                  >
                    <$Collapse
                      bordered={false}
                      defaultActiveKey={["1", "2"]}
                      expandIcon={({ isActive }) =>
                        isActive ? <MinusOutlined /> : <PlusOutlined />
                      }
                      className="bui-collapse"
                      style={{ marginLeft: 0, paddingLeft: 0 }}
                    >
                      <$Collapse.Panel
                        header={t("US.COLLECTION.COMMON:COMMON.CONTACT_PERSON")}
                        key="2"
                        style={{ marginLeft: 0, paddingLeft: 0 }}
                      >
                        <div
                          className="pb-4"
                          style={{ marginLeft: 0, paddingLeft: 0 }}
                        >
                          <ContactPersonsInfoTable
                            tableData={values?.contactPersons}
                          />
                        </div>
                      </$Collapse.Panel>
                    </$Collapse>
                  </div>
                )}
              </$Form>

              <div className="drawer-footer-fixed align-content-center justify-content-end">
                <div>
                  <$Button
                    className="mr-2"
                    data-testid="save-btn"
                    onClick={() => submitFormData(values, true)}
                    type="primary"
                  >
                    {t("US.COLLECTION.ADMIN:CREDITOR_APPROVAL.APPROVAL")}
                  </$Button>
                  <$Button onClick={() => submitFormData(values, false)}>
                    {t("US.COLLECTION.ADMIN:CREDITOR_APPROVAL.REJECT")}
                  </$Button>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>
    );
  });

const mapStateToProps = (state: RootState) => {
  const { creditorApprovalInfo } = state;
  const { pendingApprovalsList } = creditorApprovalInfo;

  return {
    pendingApprovalsList,
  };
};

const { creditorApprovalInfo } = Actions;
const { creditorApproval } = creditorApprovalInfo;

const mapDispatchToProps = {
  addNewCreditorApproval: creditorApproval.save,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(NewCreditorApproval);
